import React, {useEffect, useState} from 'react'
import {
  EducationPrograms,
  EducationSliderInfo,
  EducationWithGenerium,
  InfoBlockEducation,
  OurMission,
  StudentsAboutGenerium,
  ContactsNew
} from './index'
import styles from './styles.module.scss'
import smoothscroll from 'smoothscroll-polyfill'

const Education = ({ ourRef, setActivePopUp, checkDomenNameState, captchaSiteKey }) => {
  smoothscroll.polyfill()
  const [checkRef, setCheckRef] = useState('')

  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])
  return (
    <div className={styles.wrapper}>
      <EducationWithGenerium/>
      <OurMission />
      <EducationSliderInfo />
      <EducationPrograms />
      <StudentsAboutGenerium />
      <InfoBlockEducation />
      <ContactsNew checkDomenNameState={checkDomenNameState} setCheckRef={setCheckRef} captchaSiteKey={captchaSiteKey} />
    </div>
  )
}

export default Education
